import { target } from './form.js'

export default target
